import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "couponCode",
    initialState: "",
    reducers: {
        set: (state, action) => action.payload,
    },
});
